import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { useConfig } from '@kega/sps-core';

import { Loader } from '@kega/sps-elements';

import BuilderContentLazy from '../../modules/builder/BuilderContentLazy';

import useTranslatePath from '../../hooks/useTranslatePath';

import NotFound from '../notfound/NotFound';

const Builder = () => {
    const config = useConfig();
    const baseUrl = config.get('baseUrl');
    const storeCode = config.get('storeCode');
    const storeViews = config.get('storeViews');

    const { urlPathWithoutStore } = useTranslatePath();

    const { pathname } = useLocation();
    
    return (
        <>
            <Helmet>
                <link rel="canonical" href={`${baseUrl}/${storeCode}/${urlPathWithoutStore}`} />
                {
                    storeViews
                    &&
                    Object.keys(storeViews).map((storeCode) => {
                        const href = window.location.origin + '/' + storeCode + '/' + urlPathWithoutStore;
                        const lang = storeCode.split('_')[0] === 'be' ? storeCode.split('_').reverse().join('-') : storeCode.split('_').join('-');

                        return <link key={href} rel="alternate" hrefLang={ lang } href={href} />
                    })
                }
            </Helmet>
            <div style={{ overflow: urlPathWithoutStore.split('/')[0] === 'blog' ? 'visible' : 'hidden' }}>
                <BuilderContentLazy
                    model="page"
                    url={pathname}
                    renderLoading={() => <Loader />}
                    renderNotFound={() => <NotFound />}
                />
            </div>
        </>
    )
}

export default Builder;